import * as React from 'react'
import { Box, Button } from '@mui/material'
import {
  removeDuplicateIDFromSchool,
  fixDistrictAdminRoles,
} from '../../../providers/mutations'
import {
  FixDistrictAdminRoles,
  RemoveDuplicateIDFromSchool,
} from '../../../providers/resources'
import { makeKiddomPostRequest } from 'infrastructure/api'

export function CleanupTools() {
  const [response, setResponse] = React.useState<React.ReactElement[]>()

  const removeDuplicates = () => {
    removeDuplicateIDFromSchool()
      .then((resp) => {
        processResponse(RemoveDuplicateIDFromSchool.key, resp)
      })
      .catch((error) => {
        const msg = `Error Occured in ${RemoveDuplicateIDFromSchool.key} ${error}`
        setResponse([<p key="errorMsg">{msg}</p>])
      })
  }

  const fixDistrictAdmin = () => {
    fixDistrictAdminRoles()
      .then((resp) => {
        processResponse(FixDistrictAdminRoles.key, resp)
      })
      .catch((error) => {
        const msg = `Error Occured in ${FixDistrictAdminRoles.key} ${error}`
        setResponse([<p key="errorMsg">{msg}</p>])
      })
  }

  const fixMissingRolesInRoleTable = async () => {
    try {
      const { error } = await makeKiddomPostRequest({
        kiddomPath: `/v1/kat/cleanup/users_without_roles`,
        requestBody: {},
      })
      if (error != null) {
        setResponse([<p key="errorMsg">{error}</p>])
      }
    } catch (err) {
      const msg = `Error Occured while attempting to correct roles table ${err}`
      setResponse([<p key="errorMsg">{msg}</p>])
    }
  }

  const fixMissingSchoolRoles = async () => {
    try {
      const { error } = await makeKiddomPostRequest({
        kiddomPath: `/v1/kat/cleanup/users_without_school_roles`,
        requestBody: {},
      })
      if (error != null) {
        setResponse([<p key="errorMsg">{error}</p>])
      }
    } catch (err) {
      const msg = `Error Occured while attempting to correct roles table ${err}`
      setResponse([<p key="errorMsg">{msg}</p>])
    }
  }

  function processResponse(functionCalled: string, resp: any) {
    const currResponses = []
    currResponses.push(`Results for ${functionCalled}`)
    const respArray = resp.data[functionCalled]
    for (const item of respArray) {
      currResponses.push(`${item.Message}: ${item.Value}`)
    }
    const listResponse = currResponses.map((item) => <p key={item}>{item}</p>)
    setResponse(listResponse)
  }

  return (
    <Box>
      <Box width="80%">
        <b>Cleanup Options</b>
        <Box>
          <p>
            This action will remove any duplicate entries in the{' '}
            <b>lusers_schools</b>. This will most likely only have an impact in
            the dev and staging environment since production has a uniqueness
            constraint
          </p>
          <Button onClick={removeDuplicates}>
            Delete Duplicate School Users
          </Button>
          <p>
            This action will ensure that users that exist in the{' '}
            <b>users_districts</b> table also exist in the <b>role</b> table
            with a <i>district-admin</i> role. It also ensures that users in the{' '}
            <b>role</b> table also exist in the <b>users_districts</b> table
          </p>
          <Button onClick={fixDistrictAdmin}>Fix District Admin Roles</Button>
          <p>
            This action will sync the <b>lusers_schools</b> roles with the{' '}
            <b>roles</b> table. Thus making sure that any user that does not
            have roles properly setup, now will.
          </p>
          <Button onClick={fixMissingRolesInRoleTable}>
            Fix Users With Missing roles
          </Button>
          <p>
            This action will sync the <b>roles</b> table with the{' '}
            <b>lusers_schools</b> table for users with empty role. Thus making
            sure that any user that does not have roles properly setup, now
            will.
          </p>
          <Button onClick={fixMissingSchoolRoles}>
            Fix Users With Missing School Roles
          </Button>
        </Box>
      </Box>
      <Box>
        <b>Results</b>
        <Box>{response}</Box>
      </Box>
    </Box>
  )
}
